import styled from "styled-components"

export const PostImageDIV = styled.div`
  .Wistia {
    margin: 0;
  }

  cite {
    display: block;
    font-size: var(--font-size--XS);
    font-style: italic;
    line-height: var(--line-height--relaxed);
    margin-top: var(--spacing--XS);
    text-align: center;
  }
`

export const PostImageFrameDIV = styled.div`
  border-radius: var(--border-radius--M);
  overflow: hidden;

  img,
  .gatsby-image-wrapper {
    display: block !important;
    max-width: 610px;
    margin: 0 auto;
  }
  
  .use-extended-image & {
    img,
    .gatsby-image-wrapper {
      max-width: none;
    }
  }
`
